import React, { useState, useEffect, useRef } from "react";
import { IPriceClass } from 'types/product';
import cn from "classnames";

interface IProps {
  options: IPriceClass[];
  value: IPriceClass;
  onChange: (value: IPriceClass) => void;
  text?: string;
}

const SelectClass: React.SFC<IProps> = ({ ...props }) => {

  const [showDropdownMenu, setShowDropdownMenu] = useState(false);

  // const getSelectedName = (value: number) => {
  //   const item = props.options.find(i => value === i.id);
  //   return item ? item.name : '';
  // }

  const wrapperRef= useRef<HTMLDivElement>(null);

  useEffect(() => {
    document.addEventListener("click", handleClickOutside, false);
    return () => {
      document.removeEventListener("click", handleClickOutside, false);
    };
  }, []);

  const handleClickOutside = (event: any) => {
    if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
      setShowDropdownMenu(false);
    }
  };

  const handleShowDropdownMenu = () => {
    setShowDropdownMenu(!showDropdownMenu);
  }

  return (
    <div className={cn("dropdown", {show: showDropdownMenu})} ref={wrapperRef}>
      <span className="card__comment-span d-block ml-0">{props.text}</span>
      <button
        className="btn-secondary dropdown-toggle drop-custom px-0 py-0"
        type="button"
        id="dropdownMenuButton"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
        onClick={handleShowDropdownMenu}
      >
        <span>{props.value ? props.value.car_class_name : ''}</span>
        <svg
          width="12"
          height="7"
          viewBox="0 0 12 7"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0.443571 1.35587C0.141206 1.04581 0.141206 0.542613 0.443571 0.232549C0.745445 -0.0775162 1.23511 -0.0775162 1.53698 0.232549C1.81707 0.520233 3.21726 1.95864 5.73777 4.54781C8.25829 1.95864 9.65873 0.520483 9.93856 0.232801C10.2407 -0.0772647 10.7303 -0.0772647 11.0322 0.232801C11.3341 0.542865 11.3341 1.04581 11.0322 1.35612C10.5575 1.84373 6.75921 5.74507 6.28447 6.23267C6.13342 6.38758 5.9356 6.46503 5.73777 6.46503C5.53995 6.46503 5.34213 6.38758 5.19106 6.23242C4.24162 5.25721 0.918295 1.84347 0.443571 1.35587Z"
            fill="#848484"
          />
        </svg>
      </button>
      <div className={showDropdownMenu ? "dropdown-menu show" : 'dropdown-menu'} aria-labelledby="dropdownMenuButton">
        {props.options.map((option, index) =>
          <div className="dropdown-item" key={`item-${index}`} onClick={() => { props.onChange(option); handleShowDropdownMenu() }}>
            {option.car_class_name}
          </div>
        )}
      </div>
    </div>
  );
};

export default SelectClass;
